import AdminLayout from "./AdminLayout";
import LogsManagement from "./LogsManagement";

function Logs() {
  return (
    <AdminLayout>
      <LogsManagement />
    </AdminLayout>
  );
}

export default Logs;
